//import { CONFIG } from '../config/constant';

import { CONFIG } from "./config";

class Api {

    static authToken = '';

    static servers = [
        //{ id: 7, url: '127.0.0.1:9000', name: 'Entretenimiento', main: true },
        { id: 4, url: '64.94.95.122:9000', name: 'Entretenimiento', main: true },
        { id: 5, url: '23.131.184.92:9002', name: 'General + HD', main: false },
        { id: 9, url: '23.153.217.197:9002', name: 'Respaldo', main: false },

        //{ id: 3, url: '64.94.95.210:9000', name: 'Deportes', main: false },
        //{ id: 6, url: '181.214.182.122:9000', name: '24/7', main: false },

    ];

    static servers2 = [
        { id: 6, url: '127.0.01:9000', name: 'Objeto 1', main: true }
    ];

    static async get(endpoint, server = -1, hash = "", options = {}) {

        if (server === -1) {
            server = this.servers.find(item => item.main).id;
            if (!server) {
                return '';
            }
        }


        const headers = {
            'Authorization': `Bearer ${this.authToken}`,
            'Content-Type': 'application/json',
        };

        const url = this.servers.find(item => item.id === server).url;

        const response = await fetch(`http://${url}/api${endpoint}`, {
            method: "GET",
            headers: headers
        }
        );
        const data = await response.json();

        return data;
    }

    static async post(endpoint, data, server = -1, hash = "") {

        if (server === -1) {
            server = this.servers.find(item => item.main).id;
            if (!server) {
                return '';
            }
        }

        const url = this.servers.find(item => item.id === server).url;

        const headers = {
            'Authorization': `Bearer ${this.authToken}`,
            "Content-Type": "application/json",
            "X-Hash": hash
        };

        const response = await fetch(`http://${url}/api${endpoint}`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        });

        const result = await response.json();
        return result;
    }

    static async postLogin(endpoint, data, server = -1, hash = "") {

        if (server === -1) {
            server = this.servers.find(item => item.main).id;
            if (!server) {
                return '';
            }
        }

        const url = this.servers.find(item => item.id === server).url;

        const headers = {
            "Content-Type": "application/json",
        };

        const response = await fetch(`http://${url}${endpoint}`, {
            method: "POST",
            headers: headers,
            body: JSON.stringify(data)
        });

        const result = await response.json();
        return result;
    }

    static async delete(endpoint, data = "", hash = "") {
        const headers = {
            "Content-Type": "application/json",
            "X-Hash": hash
        };

        const response = await fetch(`${CONFIG.apiUrl}${endpoint}`, {
            method: "DELETE",
            headers,
            body: JSON.stringify(data)
        });

        //const responseData = await response.json();
        const responseData = await response.text();
        return responseData;
    }
}


export const fetchApi = async (endpoint, hash = "", options = {}) => {
    try {
        const headers = {
            "Content-Type": "application/json",
            "X-Hash": hash
        };

        const response = await fetch(`${CONFIG.apiUrl}${endpoint}`, {
            headers,
            ...options
        });
        const data = await response.json();

        return data;
    } catch (error) {
        console.error("Error fetching data:", error);
        throw error;
    }
};

export const postApi = async (endpoint, hash, data) => {
    try {
        const headers = {
            "Content-Type": "application/json",
            "X-Hash": hash
        };

        const response = await fetch(`${CONFIG.apiUrl}${endpoint}`, {
            method: "POST",
            headers,
            body: JSON.stringify(data)
        });

        const responseData = await response.text();
        return responseData;
    } catch (error) {
        console.error("Error posting data:", error);
        throw error;
    }
};

export default Api;
